<template>
  <div>
    <b-modal ref="my-modal" centered hide-footer :title="'Edit Service'">
      <form v-on:submit.prevent="doSubmitService">
        <label class="labels">Bill Number *</label>
        <b-form-input :required="true" for-input="billNumber" type="text" name="billNumber" id="billNumber" label="Bill Number" placeholder="Enter Bill Number" v-validate="modelValidations.billNumber" :error="errors.first('billNumber')" v-model="model.billNumber" data-vv-as="billNumber"/><br>
        <label class="labels">Service Date *</label>
        <b-form-datepicker
          id="serviceDate"
          name="serviceDate"
          :required="true"
          v-model="serviceDate"
          v-validate="modelValidations.serviceDate"
          v-bind:class="errors.has('serviceDate') ? 'is-invalid':''"
          locale="en-US"
          placeholder="No Date Selected"
        ></b-form-datepicker><br>
        <label class="labels">Amount *</label>
        <b-form-input :required="true" for-input="amount" type="number" name="amount" id="amount" label="Amount" placeholder="Enter Amount" v-validate="modelValidations.amount" :error="errors.first('amount')" v-model="model.amount" data-vv-as="amount"/><br>
        <label class="labels">bill status *</label>
        <div class="form-group" :required="true" v-bind:class="errors.has('status') ? 'has-error':''">
          <b-form-select name="status" v-model="model.status" v-validate="modelValidations.status" v-bind:class="errors.has('status') ? 'is-invalid':''" :error="errors.first('status')" :options="statusList">
          </b-form-select>
        </div>
        <label class="labels mt-3">Bill Photo </label>
        <div class="expander">
          <b-form-file :required="false" label="Photo" for-input="photoinputGroupFile" :error="errors.first('photoBill1')" v-model="model.photoBill1">
          </b-form-file>
          <!-- <b-form-file :required="true" label="Photo" for-input="photoinputGroupFile" :error="errors.first('photoBill1')" v-model="model.photoBill1">
            <div class="input-group">
              <div class="custom-file">
                <b-form-input type="file" class="custom-file-input" ref="photoBill1" @change="onFileSelectedPhoto" id="photoinputGroupFile" accept="image/jpeg, image/png, image/jpg" name="photoBill1" v-validate="modelValidations.photoBill1" :error="errors.first('photoBill1')" data-vv-as="photoBill1"/>
                <label class="custom-file-label" for="photoinputGroupFile">{{model.photoBill1 !== null ? model.photoBill1.name : 'Choose file'}}</label>
              </div>
              <div v-if="model.photoBill1 !== null" class="input-group-append">
                <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImagePhoto"><font-awesome-icon icon="times"/></span>
              </div>
            </div>
          </b-form-file> -->
        </div><br>
        <!-- <label class="labels">Bill Photo *</label>
        <div class="expander"> -->
          <!-- <b-form-file v-if="this.model.uuid === null" :required="true" label="Photo" for-input="photoinputGroupFile" :error="errors.first('photoBill1')" v-model="model.photoBill1">
          </b-form-file>
          <b-form-input v-else :required="true" label="Photo" for-input="photoinputGrinputile" :error="errors.first('photoBill1')" v-model="model.photoBill1">
          </b-form-input> -->
          <!-- <div class="input-group">
              <div class="custom-file">
                <b-form-input type="file" class="custom-file-input" ref="photoBill1" @change="onFileSelectedPhoto" id="photoinputGroupFile" accept="image/jpeg, image/png, image/jpg" name="photoBill1" v-validate="modelValidations.photoBill1" :error="errors.first('photoBill1')" data-vv-as="photoBill1"/>
                <label class="custom-file-label" for="photoinputGroupFile">{{model.photoBill1 !== null ? model.photoBill1.name : 'Choose file'}}</label>
              </div>
              <div v-if="model.photoBill1 !== null" class="input-group-append">
                <span class="input-group-text bg-danger text-white pointer" title="Clear Image" @click="clearImagePhoto"><font-awesome-icon icon="times"/></span>
              </div>
            </div> -->
          <!-- </b-form-file> -->
        <!-- </div><br> -->
        <label class="labels">Note </label>
        <b-form-input :required="false" for-input="note" type="text" name="note" id="note" label="Note" placeholder="Enter Note" v-validate="modelValidations.note" :error="errors.first('note')" v-model="model.note" data-vv-as="note"/><br>
        <b-button variant="warning" class="btn-back float-right" type="submit"><font-awesome-icon icon="save"></font-awesome-icon> Update </b-button>
        <b-button variant="secondary" class="float-left mr-3" @click="hideModal"><font-awesome-icon icon="times-circle"></font-awesome-icon> Cancel</b-button>
      </form>
    </b-modal>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        apiUrl: {
          vehicleBillInfo: window.AppConfig.apiUrl + 'vehicle-bill-info',
        },
        type: null,
        model: {
          uuid: null,
          options: [],
          dueDate: null,
          type: "Service",
          status: "New",
          vehicle: null,
          billNumber: null,
          amount: 0,
          photoBill1: null,
          note: "",
        },
        statusList: [
          {
            value: 'New',
            text: 'Waiting For Payment'
          },
          {
            value: 'Paid',
            text: 'Paid'
          }
        ],
        serviceDate: null,
        modelValidations: {
          billNumber: {
            required: true
          },
          serviceDate: {
            required: true
          },
          amount: {
            required: true
          },
          photoBill1: {
            required: true
          }
        },
        photos: [],
        photo: {
          uuid1: null,
          uuid2: null,
          photoBill1: null,
          photoBill2: null,
        }
      }
    },
    methods: {
      doSubmitService() {
        this.$validator.validateAll().then(res => {
          if (res) {
            this.isLoading = true
            let serviceDate = {name: "ServiceDate", value: this.serviceDate};
            this.model.options.push(serviceDate)

            // this.photos = [
            //   {
            //     "photoBillUuid1": this.photo.uuid1,
            //     "photoBill1": this.photo.photoBill1
            //   },
            //   {
            //     "photoBillUuid2": this.photo.uuid2,
            //     "photoBill2": this.photo.photoBill2
            //   }
            // ]

            let formData = new FormData()
            formData.append('billNumber', this.model.billNumber)
            formData.append('amount', this.model.amount)
            formData.append('dueDate', this.serviceDate)
            formData.append('status', this.model.status)
            // formData.append('options', this.model.options)
            // formData.append('options', JSON.stringify(this.model.options))
            // if (this.model.options !== null) {
            // formData.append('options', JSON.stringify(this.model.options))
            // }
            // formData.append('serviceDate', this.model.serviceDate)
            formData.append('note', this.model.note ? this.model.note : '-')
            if (this.model.photoBill1 !== null) {
              formData.append('photoBill1', this.model.photoBill1)
            }
            if (this.model.uuid !== null) {
              let model = {}
              Object.keys(this.model).forEach(element => {
                if (element !== 'uuid') {
                  model[element] = this.model[element]
                }
              })
              this.$http.patch(this.apiUrl.vehicleBillInfo + '/' + this.model.uuid, formData).then(response => {
                this.isLoading = false
                this.$store.dispatch('notification/success', 'Service data successfully updated.')
                this.hideModal()
                this.resetData()
                this.$emit('getServiceBill')
              }).catch(error => {
                this.isLoading = false
                this.$store.dispatch('notification/error', error)
              })
            }
          }
        })
      },
      resetData () {
        this.model.uuid = null
        this.serviceDate = null
        // this.model.photoBill1 = null
        this.model.note = null
        this.model.amount = 0
        this.model.billNumber = null
        this.model.status = null
        this.$validator.reset()
      },
      showModal(row) {
        this.model.uuid = row.uuid
        this.serviceDate = row.dueDate !== null ? this.getDate(row.dueDate) : ''
        this.model.note = row.note !== null && row.note !== '' && row.note !== 'null' ? row.note : '-'
        this.model.amount = row.amount
        this.model.billNumber = row.billNumber
        this.model.status = row.status
        // this.model.photoBill1 = row.vehicleBillPhoto[0].url
        // this.model.photoBillUuid1 = row.vehicleBillPhoto[0].uuid
        this.$validator.reset();
        this.$refs['my-modal'].show()
      },
      onFileSelectedPhoto (event) {
        this.model.photoBill1 = event.target.files[0]
      },
      clearImagePhoto () {
        this.$refs.photoBill1.value = ''
        this.model.photoBill1 = null
      },
      hideModal () {
        this.resetData()
        this.$refs['my-modal'].hide()
      },
      getDate (value) {
        if (value !== null) {
          return this.$moment(value).format('YYYY-MM-DD')
        } else {
          return '-'
        }
      },
    }
  }
</script>